"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconSend = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconSend = function SvgIconSend(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.1583 0.0338791C11.6575 -0.132551 12.1326 0.342457 11.9661 0.841746L8.39228 11.5633C8.20569 12.123 7.42479 12.1521 7.19715 11.6077L5.39278 7.2929C5.26323 6.98311 5.01692 6.73679 4.70713 6.60725L0.392287 4.80285C-0.152076 4.57521 -0.12304 3.79431 0.436725 3.60772L11.1583 0.0338791Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  }))));
};

exports.SvgIconSend = SvgIconSend;